export interface Currency {
  code: string;
  symbol: string;
  name: string;
}

export const SUPPORTED_CURRENCIES: Currency[] = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' }
];

export const getCurrencySymbol = (currencyCode: string): string => {
  const currency = SUPPORTED_CURRENCIES.find(c => c.code === currencyCode);
  return currency ? currency.symbol : '$';
};

export const getCurrencyName = (currencyCode: string): string => {
  const currency = SUPPORTED_CURRENCIES.find(c => c.code === currencyCode);
  return currency ? currency.name : 'US Dollar';
};

export const formatPrice = (price: number, currencyCode: string): string => {
  const symbol = getCurrencySymbol(currencyCode);
  
  // Special formatting for different currencies
  switch (currencyCode) {
    case 'INR':
      // Indian Rupee formatting (₹2,499.00)
      return `${symbol}${price.toLocaleString('en-IN', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      })}`;
    case 'EUR':
      // Euro formatting (€80.00)
      return `${symbol}${price.toLocaleString('en-US', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      })}`;
    case 'GBP':
      // British Pound formatting (£80.00)
      return `${symbol}${price.toLocaleString('en-GB', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      })}`;
    case 'CAD':
    case 'AUD':
      // Canadian/Australian Dollar formatting (C$100.00, A$100.00)
      return `${symbol}${price.toLocaleString('en-US', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      })}`;
    case 'USD':
    default:
      // US Dollar formatting ($100.00)
      return `${symbol}${price.toLocaleString('en-US', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      })}`;
  }
};

export const getDefaultCurrency = (): string => {
  // Get user's preferred currency from localStorage or default to USD
  return localStorage.getItem('fragrance-organizer-currency') || 'USD';
};

export const setDefaultCurrency = (currencyCode: string): void => {
  localStorage.setItem('fragrance-organizer-currency', currencyCode);
};
